const zeroGuid = "00000000-0000-0000-0000-000000000000";
const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const OTHER_SUBSCRIPTION_OPTION = "__other__";
export const normalizeAzureSubscriptionGuid = (value) => {
    const normalized = value === null || value === void 0 ? void 0 : value.trim().toLowerCase();
    if (!normalized ||
        normalized === zeroGuid ||
        !guidPattern.test(normalized)) {
        return undefined;
    }
    return normalized;
};
